import { createVNode as t, mergeProps as s } from "vue";
import a from "../node_modules/@pf-ui/pf-icon-svg/es/asn/CollapseFilled.js";
import i from "../components/PfIcon.js";
const e = (l, o) => {
  const r = {
    ...l,
    ...o.attrs
  };
  return t(i, s(r, {
    icon: a
  }), null);
};
e.displayName = "CollapseFilled";
e.inheritAttrs = !1;
export {
  e as default
};
